import { gql } from '@apollo/client';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import { RequestDjInput } from '../../../apollo/__generated__/graphql';

export type RequestDjMutation = {
  requestDj: {
    id: string;
  };
};

export type RequestDjMutationVariables = {
  requestDjInput: RequestDjInput;
};

export const REQUEST_DJ = gql`
  mutation RequestDj($requestDjInput: RequestDjInput!) {
    requestDj(requestDjInput: $requestDjInput) {
      id
    }
  }
` as DocumentNode<RequestDjMutation, RequestDjMutationVariables>;
